import { cloneDeep, isNil } from 'lodash';

import { CallList, OrgData, SerializableObjectWithNoParams, UserData, VoiceResponseCommand } from '@pwp-common';

import { dbToCommunicationWorkflowConfigEditorOutput } from '../../../../call-list-communication-workflow-config/editor-output/db-to-communication-workflow-config-editor-output/db-to-communication-workflow-config-editor-output';
import { makeCallListOfferConfigRingTimeEditorOutput } from '../../../../call-list-offer-config-ring-time/editor/editor-output/make-offer-config-ring-time-editor-output/make-call-list-offer-config-ring-time-editor-output';
import { dbToCallerIdStrategyEditorOutput } from '../../../../caller-id-strategy/editor-output/db-to-caller-id-strategy-editor-output/db-to-caller-id-strategy-editor-output';
import { ServiceCommandEditorOutput } from '../../../../service-operation-editor/editor-output/service-command-editor-output';
import { calleeEntitiesToEditorOutput } from '../../../../workers-autocomplete/editor-output/callee-entities/callee-entities-to-editor-output/callee-entities-to-editor-output';
import { CallListEditorOutput } from '../call-list-editor-output';
import { defaultCallListEditorOutput } from '../default-call-list-editor-output';

const serializeCommand = (command: VoiceResponseCommand): ServiceCommandEditorOutput =>
  (command as unknown as SerializableObjectWithNoParams).serialize() as ServiceCommandEditorOutput;

export const makeCallListEditorOutput = (
  input: CallList | CallListEditorOutput,
  users: Map<string, UserData>,
  orgData: OrgData,
): CallListEditorOutput => {
  if (isNil(input)) {
    return cloneDeep(defaultCallListEditorOutput);
  }

  if (input instanceof CallList) {
    const result: CallListEditorOutput = {
      id: input.getId(),
      displayName: input.getDisplayName(),
      description: input.getDescription(),
      calleeEntities: calleeEntitiesToEditorOutput(input.getCalleeEntities(), users, orgData),
      offerConfig: {
        ringTime: makeCallListOfferConfigRingTimeEditorOutput(input),
        callerId: dbToCallerIdStrategyEditorOutput(input?.getOfferConfig()),
      },
      onNoUserLeftToDialModIncCallCommands: {
        commands: input.getOnNoUserLeftToDialModIncCallCommands().map(serializeCommand),
      },
      communicationWorkflowConfig: dbToCommunicationWorkflowConfigEditorOutput(input.getCommunicationWorkflowConfig()),
    };

    return result;
  }

  return input;
};
